<template>
    <div class="mx-4 mt-4">
        <div class="row g-4">
            <div class="col-12 col-lg-3 d-flex">
                <div class="card h-100 shadow-sm border-2 p-4 rounded-4 card-cuadrada">
                    <div class=" align-items-center">

                        <div class="d-flex justify-content-between align-items-center">
                            <i class="bi bi-filetype-xls text-success display-6"></i>
 
                            <div>
                                <button class="btn btn-success px-3 py-2 shadow-sm rounded-3" :disabled="excelIsLoading"
                                    @click="descargarExcel">
                                    <i class="bi bi-download "></i>
                                </button>
                            </div>
                        </div>

                        <div>
                            <h5 class="mt-3 mb-2 card-title">Reporte por Contrato</h5>

                            <p class="mb-0">
                                Descarga el archivo Excel con todos los contratos registrados.
                            </p>

                            <!-- SWITCH -->
                            <!-- <label class="google-switch mt-1">
                <input type="checkbox" v-model="activarReportes">
                <span class="google-slider"></span>
              </label> -->

                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 col-lg-3 d-flex">
                <div class="card h-100 shadow-sm border-2 p-4 rounded-4 card-cuadrada">

                    <div class="align-items-center">

                        <div class="d-flex justify-content-between align-items-center">
                            <div class="d-flex justify-content-between align-items-center">
                                <i class="bi bi-filetype-xls text-success display-6"></i>
                            </div>
                            <div>
                                <button class="btn btn-success px-3 py-2 shadow-sm rounded-3"
                                    :disabled="ExcelReport "  @click="ReporteAuditorias">
                                    <i class="bi bi-download "></i>
                                </button>
                            </div>
                        </div>

                        <div>
                            <h4 class="mt-3 mb-2 card-title">Reporte  Periodo</h4>

                            <p class="mb-0">
                                Selecciona un año y mes para descargar el reporte filtrado.
                            </p>

                            <!-- <label class="google-switch mt-1">
                                <input type="checkbox" v-model="activarReportesPeriodo">
                                <span class="google-slider"></span>
                            </label> -->
                        </div>

                    </div>

                    <div class="mt-4">
                        <select class="form-select mb-3" :disabled="ExcelReport "
                            v-model="perAno">
                            <option value="0" disabled>-- SELECCIONAR AÑO --</option>
                            <option v-for="año in años" :key="año.value" :value="año.value">
                                {{ año.label }}
                            </option>
                        </select>

                        
                        <select class="form-select mb-3" :disabled="ExcelReport "
                            v-model="perMes">
                            <option value="0" disabled>-- SELECCIONAR MES --</option>
                            <option v-for="mes in meses" :key="mes.value" :value="mes.value">
                                {{ mes.label }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>

              <!-- <div class="col-12 col-lg-3 d-flex">
                <div class="card h-100 shadow-sm border-2 p-4 rounded-4 card-cuadrada">

                    <div class="align-items-center">

                        <div class="d-flex justify-content-between align-items-center">
                            <div class="d-flex justify-content-between align-items-center">
                                <i class="bi bi-filetype-xls text-success display-6"></i>
                            </div>
                            <div>
                                <button class="btn btn-success px-3 py-2 shadow-sm rounded-3"
                                    :disabled="ExcelReport "  @click="ReporteAuditorias">
                                    <i class="bi bi-download "></i>
                                </button>
                            </div>
                        </div>

                        <div>
                            <h4 class="mt-3 mb-2 card-title">Reporte  Periodo</h4>

                            <p class="mb-0">
                                Selecciona un año y mes para descargar el reporte filtrado.
                            </p>

                        </div>

                    </div>

                    <div class="mt-4">
                        <select class="form-select mb-3" :disabled="ExcelReport "
                            v-model="perAno">
                            <option value="0" disabled>-- SELECCIONAR AÑO --</option>
                            <option v-for="año in años" :key="año.value" :value="año.value">
                                {{ año.label }}
                            </option>
                        </select>

                        
                        <select class="form-select mb-3" :disabled="ExcelReport "
                            v-model="perMes">
                            <option value="0" disabled>-- SELECCIONAR MES --</option>
                            <option v-for="mes in meses" :key="mes.value" :value="mes.value">
                                {{ mes.label }}
                            </option>
                        </select>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</template>




<script>
export default {
    name: "SolimanologContratosReportes",

    data() {
        return {
            excelIsLoading: true,

            
            excel: null,
            perAno: "0",
            perMes: "0",
            años: [
                { value: "2022", label: "2022" },
                { value: "2023", label: "2023" },
                { value: "2024", label: "2024" },
                { value: "2025", label: "2025" },
                { value: "2026", label: "2026" },
            ],
            meses: [
                { value: "01", label: "Enero" },
                { value: "02", label: "Febrero" },
                { value: "03", label: "Marzo" },
                { value: "04", label: "Abril" },
                { value: "05", label: "Mayo" },
                { value: "06", label: "Junio" },
                { value: "07", label: "Julio" },
                { value: "08", label: "Agosto" },
                { value: "09", label: "Septiembre" },
                { value: "10", label: "Octubre" },
                { value: "11", label: "Noviembre" },
                { value: "12", label: "Diciembre" },

            ],
            idTrabajador: "",
            ExcelReport: false
        };
    },

    mounted() { },
    created() {
        this.cambiarEstadoNavbar()
        this.reporte()
        this.idTrabajador = localStorage.getItem('idTrabajdor')
    },

    methods: {
        cambiarEstadoNavbar() {
            // Acción directa para cambiar el estado del navbar a true
            this.$store.dispatch("acciones/CambioNavbar", true);
        },
        reporte() {
            this.axios
                .get("ReportesExcel/ReportContratoSubido", { responseType: "blob" })
                .then((response) => {
                    this.excelIsLoading = false;
                    this.excel = response.data;
                });
        },

        descargarExcel() {
            var fileURL = window.URL.createObjectURL(new Blob([this.excel]));
            var fileLink = document.createElement("a");

            fileLink.href = fileURL;
            fileLink.setAttribute("download", "ReporteContratos.xlsx");
            document.body.appendChild(fileLink);

            fileLink.click();
        },

        ReporteAuditorias() {
            if (this.perAno === "0" || this.perMes === "0") {
                return;
            }

            const periodo = `${this.perAno}${this.perMes}`;
            this.ExcelReport = true

            this.axios.get(`ReportesExcel/ReporteContratosAuditoria?idTrabajador=${this.idTrabajador}&periodo=${periodo}`, {
                responseType: "blob" // 👈 IMPORTANTE PARA ARCHIVOS
            })
                .then((response) => {
                    const blob = new Blob([response.data], {
                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    });
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement("a");

                    link.href = url;
                    link.download = `ReporteAuditoria_${periodo}.xlsx`;
                    link.click();

                    window.URL.revokeObjectURL(url);
                })
                .catch((error) => {
                    console.error("❌ Error descargando Excel:", error);
                }).finally(() => {
                    this.ExcelReport = false; // ✔ Termina carga
                });
        }
    },
};
</script>

<style scoped>
.google-switch-container {
    display: flex;
    align-items: center;
}

/* Contenedor del switch */
.google-switch {
    position: relative;
    width: 46px;
    height: 26px;
    display: inline-block;
}

/* Checkbox oculto */
.google-switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

/* Fondo */
.google-slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #e5e7eb;
    /* gris claro */
    border-radius: 34px;
    transition: 0.3s;
}

/* Círculo */
.google-slider:before {
    position: absolute;
    content: "";
    height: 20px;
    width: 20px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    border-radius: 50%;
    transition: 0.3s;
}

/* Activado */
.google-switch input:checked+.google-slider {
    background-color: #4f9ef9;
    /* azul Google */
}

.google-switch input:checked+.google-slider:before {
    transform: translateX(20px);
}

.reducirTamaño {
    font-size: 0.65rem;
}

.card-cuadrada {
    border-radius: 0 !important;
    /* estilo más corporativo */
    border: 1px solid #e5e5e5 !important;
}
</style>